import React, { useState } from 'react'
import moment from 'moment';
import { Button } from 'components/Button';
import { Col, Progress, Row, Table, Empty, DatePicker } from 'antd';
import { connect } from 'react-redux';
import { leaveOrAttendanceRequestActions } from 'actions/profileNew';
import RequestsConfirmationModal from 'pages/attendanceNew/Modals/requestsConfirmationModal';

// hidePagination: list every row with no pager (Users V2 profile).
const AttendanceRequestTable = ({ dataSource, setAttRequestModal, leaveOrAttendanceRequestActions, storeRowData, setStoreRowData, successCallback, hidePagination = false }) => {

    console.log({ storeRowData });

    const [reqModalTitle, setReqTitleModal] = useState('');
    const [openReqConfirmationModal, toggleReqConfirmationModal] = useState(false);
    const [rejectBtnLoader, setRejectbtnLoader] = useState(false);
    const [approveBtnLoader, setApprovebtnLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [actionObject, setActionObject] = useState({ type: '', val: '' });
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 5; // Show 5 rows per page
    
    // Get current page data
    const getCurrentPageData = () => {
        if (hidePagination) return dataSource || [];
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return dataSource?.slice(startIndex, endIndex) || [];
    };
    
    const totalPages = Math.ceil((dataSource?.length || 0) / pageSize);

    const formatTime = (time) => {
        const [hours, minutes] = time.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);

        let hours12 = date.getHours() % 12 || 12;
        let ampm = date.getHours() >= 12 ? 'PM' : 'AM';

        return `${hours12.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    };

    const formatClockInOut = (clockIn, clockOut) => {
        return `${formatTime(clockIn)} - ${formatTime(clockOut)}`;
    };

    const columns = (setDeleteLeaveModal, handleEditLeave,) => [
        {
            title: '#',
            dataIndex: 'index',
            key: 'index',
            render: (text, record, index) => {
                const globalIndex = (currentPage - 1) * pageSize + index + 1;
                return(
                <div style={{ display: 'flex', justifyContent: 'flex-start', fontFamily: 'Roboto', textAlign: 'left'}}>
                    {globalIndex}
                </div>
            )},
            align: 'left',
        },
        {
            title: 'DATE',
            dataIndex: 'dates',
            key: 'dates',
            render: (value, record) => {
                const startDate = moment(record.startDate, "YYYY-MM-DD");
                return (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        fontFamily: 'Roboto',
                        textAlign: 'left',
                        width: '100%',
                    }}>
                        {moment(startDate).format("DD/MM/YY")}
                    </div>
                );
            },
            width: '12%',
            align: 'left',
        },
        {
            title: 'TIMINGS',
            dataIndex: 'timings',
            key: 'timings',
            render: (value, record) => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    fontFamily: 'Roboto',
                    textAlign: 'left'
                }}>
                    {formatClockInOut(record?.clockIn, record?.clockOut)}
                </div>
            ),
            width: '25%',
            align: 'left',
        },
        {
            title: 'DURATION',
            dataIndex: 'duration',
            key: 'duration',
            render: (value, record) => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    fontFamily: 'Roboto',
                    textAlign: 'left'
                }}>
                    {record?.duration}
                </div>
            ),
            width: "20%",
            align: 'left',
        },
        {
            title: "STATUS",
            dataIndex: 'status',
            key: 'status',
            width: "20%",

            render: (value, record) => {
                let backgroundColor, textColor, displayText;

                switch (record?.status) {
                    case 'Approved':
                        backgroundColor = '#D5F8EF';
                        textColor = '#2EA083';
                        displayText = 'Approved';
                        break;
                    case 'Pending':
                        backgroundColor = '#FDF3CE';
                        textColor = '#DAAB00';
                        displayText = 'Pending';
                        break;
                    case 'Partially Approved':
                        backgroundColor = '#D8F6FF';
                        textColor = '#0AB1E6';
                        displayText = 'Partially\nApproved';
                        break;
                    case 'Rejected':
                        backgroundColor = '#FBE7E9';
                        textColor = '#FF414D';
                        displayText = 'Rejected';
                        break;
                    default:
                        backgroundColor = '#E5E7EB';
                        textColor = '#1F2937';
                        displayText = 'Unknown';
                }

                return (
                    <div
                        style={{
                            backgroundColor: backgroundColor,
                            color: textColor,
                            padding: '0.25rem 0.75rem',
                            justifyContent: 'center',
                            width: "80%",
                            borderRadius: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            textTransform: 'uppercase',
                            whiteSpace: 'pre-line'
                        }}
                    >
                        {displayText}
                    </div>
                );
            },
            align: 'left',
        },
        {
            title: 'ACTIONS',
            render: (value, record) => (
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    {
                        (record?.status === 'Pending') &&
                        <div style={{ display: 'flex', justifyContent: "space-between", width: '100%' }}>
                            <Button
                                style={{ textAlign: 'left', color: '#FF414D', fontWeight: 700 }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActionObject({ type: 'reject', val: record }); setReqTitleModal('Are you sure you want to reject?'); toggleReqConfirmationModal(true); setStoreRowData(record);
                                }}
                                loading={rejectBtnLoader}
                                type='transparent'
                            >
                                REJECT
                            </Button>
                            <Button
                                style={{ textAlign: 'left', color: '#00A566', fontWeight: 700 }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActionObject({ type: 'approve', val: record }); setReqTitleModal('Are you sure you want to approve?'); toggleReqConfirmationModal(true); setStoreRowData(record);
                                }}
                                loading={approveBtnLoader}
                                type='transparent'
                            >
                                APPROVE
                            </Button>
                        </div>
                    }
                    {/* Approved attendance can't be rejected — no action for Approved.
                    {(record?.status === 'Approved') &&
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                loading={buttonLoader}
                                style={{ alignItems: 'center', color: '#FF414D', fontWeight: 700 }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActionObject({ type: 'change to rejected', val: record }); setReqTitleModal('Are you sure you want to reject?'); toggleReqConfirmationModal(true); setStoreRowData(record);
                                }}
                                type='transparent'
                            >
                                CHANGE TO REJECTED
                            </Button>
                        </div>
                    }
                    */}
                    {(record?.status === 'Rejected') &&
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                loading={buttonLoader}
                                style={{ alignItems: 'center', color: '#00A566', fontWeight: 700 }}
                                onClick={(e) => { e.stopPropagation(); setActionObject({ type: 'change to approved', val: record }); setReqTitleModal('Are you sure you want to approve?'); toggleReqConfirmationModal(true); setStoreRowData(record); }}
                                type='transparent'
                            >
                                CHANGE TO APPROVED
                            </Button>
                        </div>
                    }
                </div>
            ),
            align: 'left',
        },
    ];

    const handleReject = (commonId) => {
        let params = {
            action: 'Rejected',
            commonId: [commonId],
            requestIds: []
        }

        const callback = () => {
            setRejectbtnLoader(false)

        };

        setRejectbtnLoader(true)
        leaveOrAttendanceRequestActions(params, () => callback(), () => { successCallback(), toggleReqConfirmationModal(false) })
    };

    const handleApprove = (commonId) => {
        let params = {
            action: 'Approved',
            commonId: [commonId],
            requestIds: []
        }

        const callback = () => {

            setApprovebtnLoader(false)
        };

        setApprovebtnLoader(true)
        leaveOrAttendanceRequestActions(params, () => callback(), () => { successCallback(), toggleReqConfirmationModal(false) })
    }

    const handleChangeStatus = (status, commonId) => {

        let params = {
            action: status,
            commonId: [commonId],
            requestIds: []
        }

        const callback = () => {
            setButtonLoader(false)
        };

        setButtonLoader(true)
        leaveOrAttendanceRequestActions(params, () => callback(), () => { successCallback(), toggleReqConfirmationModal(false) })
    }


    const handleActionButtons = () => {
        console.log('actionObject', storeRowData);
        switch (actionObject?.type) {
            case 'reject':
                handleReject(storeRowData?.commonId)
                break;
            case 'approve':
                handleApprove(storeRowData?.commonId)
                break;

            case 'change to approved':
                handleChangeStatus(
                    storeRowData?.status == 'Approved' ? 'Rejected' :
                        storeRowData?.status == 'Rejected' ? 'Approved' : null,
                    storeRowData?.commonId
                )
                break;
            case 'change to rejected':
                handleChangeStatus(
                    storeRowData?.status == 'Rejected' ? 'Approved' :
                        storeRowData?.status == 'Approved' ? 'Rejected' : null,
                    storeRowData?.commonId
                )
                break;
            default:
                break;
        }
    }

    const hasData = dataSource && dataSource.length > 0;

    return (
        <div>
            {hasData ? (
                <div className="border-rounded-table">
                <Table
                    className="attendancce-req-table"
                    columns={columns()}
                    dataSource={getCurrentPageData()}
                    sticky={false}  scroll={{ x: 'max-content' }}
                    pagination={hidePagination ? false : {
                        current: currentPage,
                        pageSize: pageSize,
                        total: dataSource?.length || 0,
                        onChange: (page) => setCurrentPage(page),
                        showSizeChanger: false,
                        position: ['bottomRight'],
                    }}
                    onRow={(record) => ({
                        style: { cursor: 'pointer' },
                        onClick: () => {
                            setAttRequestModal(true);
                            setStoreRowData(record);
                        },
                    })}
                />
                </div>
            ) : (
                <div className="border-rounded-table"
                    style={{
                        padding: '48px 0',
                        textAlign: 'center',
                        background: '#fff',
                        borderRadius: 8,
                    }}
                >
                    <img
                        src={require("Assets/ill-no-data.svg").default}
                        alt="No Data"
                        style={{ width: 180 }}
                    />
                    <div style={{marginTop: 16, fontSize: '18px', fontWeight: 500, color: '#191919', }}>
                        No attendance requests
                    </div>
                    <div style={{fontWeight: 400, fontSize: 14, marginTop: 8, color: '#636363',}}>
                        User has not applied for any manual attendance yet
                    </div>
                </div>
            )}
            <RequestsConfirmationModal open={openReqConfirmationModal} onCancel={() => toggleReqConfirmationModal(false)} onYes={() => handleActionButtons()} title={reqModalTitle} />
        </div>

    );
}

const mapStateToProps = (state) => {

    return {}
}

const mapDispatchToProps = (dispatch) => ({
    leaveOrAttendanceRequestActions: (params, callback, pagecallback) => dispatch(leaveOrAttendanceRequestActions(params, callback, pagecallback)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceRequestTable)
